const Footer = () => {
  return (
    <>
      <div
        style={{
          height: "30vh",
          backgroundColor: "black",
          opacity: 0.9,
          justifyContent: "center",
          alignItems: "center",
          color: "whitesmoke",
          display: "flex",
        }}
      >
        <h1>copyright @ Rahul Pandey - 2022</h1>
      </div>
    </>
  );
};

export default Footer;
